import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "youtube-icon--blue",
  "use": "youtube-icon--blue-usage",
  "viewBox": "0 0 28 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 28 20\" id=\"youtube-icon--blue\"><path d=\"M27.042 4.202C27.042 1.88 25.23 0 23 0H4.042C1.809 0 0 1.882 0 4.202v11.265c0 2.318 1.809 4.2 4.042 4.2h18.954c2.232 0 4.044-1.882 4.044-4.2V4.202h.002zM11 14.062V5l7.375 4.531L11 14.062z\" fill=\"#003595\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol